import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  LeftArrowSvg,
  RightArrowSvg,
  LeftArrowDisabledSvg,
  RightArrowDisabledSvg,
} from "./Assets";

const MonthlySelect = ({ setSelectedDate }) => {
  const [selectedMonth, setSelectedMonth] = useState(moment().month() + 1);

  // const MAX_MONTH = 12;
  const MAX_MONTH = moment().month() + 1;
  
  const setStartAndEndDate = () => {
    const firstDay = moment()
      .month(selectedMonth - 1)
      .startOf("month");
    const lastDay = moment()
      .month(selectedMonth - 1)
      .endOf("month");
    setSelectedDate(firstDay, lastDay);
  };

  const handlePrevMonth = () => {
    if (selectedMonth !== 1) {
      setSelectedMonth((prevMonth) => (prevMonth === 1 ? MAX_MONTH : prevMonth - 1));
    }
  };

  const handleNextMonth = () => {
    if (selectedMonth !== MAX_MONTH) {
      setSelectedMonth((prevMonth) => (prevMonth === MAX_MONTH ? 1 : prevMonth + 1));
    }
  };

  useEffect(() => {
    setStartAndEndDate();
  }, [selectedMonth]);

  return (
    <div>
      <div className="flex justify-between items-center">
        <div onClick={handlePrevMonth}>
          <img
            src={selectedMonth === 1 ? LeftArrowDisabledSvg : LeftArrowSvg}
            alt=""
          />
        </div>
        <div className="font-bold text-2xl text-darkblue">
          {selectedMonth}월 리포트
        </div>
        <div onClick={handleNextMonth}>
          <img
            src={selectedMonth === MAX_MONTH ? RightArrowDisabledSvg : RightArrowSvg}
            alt=""
          />
        </div>
      </div>
      <div className="text-center text-[#A0A5B5] mt-11">
        통계 기간:{" "}
        {moment()
          .month(selectedMonth - 1)
          .startOf("month")
          .format("YYYY.MM.DD")}{" "}
        ~{" "}
        {moment()
          .month(selectedMonth - 1)
          .endOf("month")
          .format("YYYY.MM.DD")}
      </div>
    </div>
  );
};

export default MonthlySelect;
